import { AnalyticsAdapter } from './types';

export class Analytics {
  private analytics: AnalyticsAdapter;

  constructor(adapter: AnalyticsAdapter) {
    this.analytics = adapter;
  }

  isInitialized() {
    return this.analytics.isInitialized();
  }

  initialize() {
    if (!this.analytics.initialize) {
      throw new Error('"initialize" method is not implemented');
    }

    this.analytics.initialize();
  }

  track(event: string, options?: Record<string, string | number | string[]>) {
    if (!this.analytics.track) {
      throw new Error('"track" method is not implemented');
    }

    this.analytics.track(event, options);
  }
}
